import { Typo3Page } from '@/types'
import { create } from 'zustand'
import createSelectors from '../utils/createSelectors'

type LayoutSeason = NonNullable<
  NonNullable<Typo3Page['appearance']>['layoutSeason']
>

interface State {
  layoutSeason: LayoutSeason
}
interface Action {
  setLayoutSeason: (layoutSeason?: State['layoutSeason']) => void
  reset: () => void
}

const baseStoreSeason = create<State & Action>((set) => ({
  layoutSeason: 'default',
  setLayoutSeason: (layoutSeason) =>
    set(() => ({ layoutSeason: layoutSeason ?? 'default' })),
  reset: () => set({ layoutSeason: 'default' })
}))

const useStoreSeason = createSelectors(baseStoreSeason)

export default useStoreSeason
